



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Icon, Accordion } from '@/pages/profile/components';
import { MentoringList } from './components';
import {
  MentoringSmallText as Small,
  MentoringMember,
} from '../../../components';
import { Meetings, PopupData, IMentoringMain, Member } from './types';

@Component({
  components: {
    Icon,
    Small,
    Accordion,
    MentoringList,
    MentoringMember,
  },
})
export default class MentoringMain extends Vue implements IMentoringMain {
  @Prop({ type: String, default: '' })
  readonly status!: string;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly startDate!: string;

  @Prop({ type: Object, default: () => {} })
  readonly curator!: Member;

  @Prop({ type: Object, default: () => {} })
  readonly mentor!: Member;

  @Prop({ type: Boolean, default: false })
  readonly isOpened!: boolean;

  @Prop({ type: Array, default: () => [] })
  readonly list!: Meetings;

  get curatorFioArray(): Array<string> {
    const { fio } = this.curator;
    return fio ? fio.split(' ') : [];
  }

  get curatorName(): string {
    const [_, name] = this.curatorFioArray;
    return name ? name : '';
  }

  get curatorLastname(): string {
    const [lastname] = this.curatorFioArray;
    return lastname ? lastname : '';
  }

  get mentorFioArray(): Array<string> {
    const { fio } = this.mentor;
    return fio ? fio.split(' ') : [];
  }

  get mentorName(): string {
    const [_, name] = this.mentorFioArray;
    return name ? name : '';
  }

  get mentorLastname(): string {
    const [lastname] = this.mentorFioArray;
    return lastname ? lastname : '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/programcard/components/main/MentoringMain.vue